<!--Main Menu-->
<div>
	<div class="SoundName">
		<label style="margin: 0">Enter Sound Name:</label>
		<input class="form-control" type="text" placeholder="ExampleSound" [(ngModel)]="SoundName" />
	</div>

	<div class="Recorder">
		<label>Record Sound:</label>

		<div class="SmallTopMargin">
			<!--Recording Controls-->
			<div class="RecordControls">
				<button id="RecordButton" name="RecordButton" *ngIf="IsRecording == false" class="btn btn-dark" (click)="onRecord()">
					<i class="fa fa-circle" style="color: red"></i>
				</button>

				<button id="PauseButton" name="PauseButton" *ngIf="IsRecording == true" class="btn btn-dark" (click)="onPause()">
					<i class="fa fa-pause" style="color: white"></i>
				</button>

				<button class="btn btn-dark" (click)="onStop()">
					<i class="fa fa-square" style="color: white"></i>
				</button>

				<button class="btn btn-dark" (click)="onReplay()">
					<i class="fa fa-play" style="color: white"></i>
				</button>
			</div>

			<!--Finish or Restart-->
			<div class="FinishControls">
				<button class="btn btn-danger">Restart</button>
				<button class="btn btn-success">Finish and Upload</button>
			</div>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="top-Margin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
